import { Modal } from "react-bootstrap";

export default function (props) {
    return (
        <Modal show={props.showModal} onHide={() => { props.setShowModal(false) }} centered>
            <div className="whole-container" style={{ textAlign: "center" }}>
                <h1 className="container-title" style={{ color: '#BD00FF' }}>Match Terminated</h1>
                <h1 className="container-body-text" style={{ color: '#FFFFFF' }}>Host has joined another match</h1>
            </div>
        </Modal>
    )
}